module.exports = __webpack_public_path__ + "img/icon-profile-blue.01a470dd.svg";